import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { FaInstagram, FaWhatsapp, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // ✅ UPDATED SCHEMA (.com FIX)
  const footerSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "Shree Ram Car Rental",
    "url": "https://www.shreeramcarrental.com", // ✅ FIXED
    "telephone": "+919755357721",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Indore",
      "addressRegion": "MP",
      "addressCountry": "IN"
    }
  };

  return (
    <footer className="main-footer" aria-label="Site Footer">
      
      {/* ✅ SCHEMA */}
      <script type="application/ld+json">
        {JSON.stringify(footerSchema)}
      </script>

      <div className="footer-container">
        
        {/* COLUMN 1 */}
        <div className="footer-col about-col">
          <h2 className="footer-logo">SHREE RAM<span> CAR RENTAL</span></h2>
          <p className="footer-desc">
            Indore's #1 <strong>self-drive car rental service</strong>. Premium fleet of 40+ vehicles 
            available 24/7 for local and outstation travel. Your journey, our priority.
          </p>

          <div className="social-links">
            <a 
              href="https://www.instagram.com/shreeramcarrentalndore?igsh=MWRyMXZ3M3BxYm91Ng%3D%3D" 
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Follow us on Instagram"
            >
              <FaInstagram size={22} />
            </a>

            <a 
              href="https://wa.me/919755357721"
              target="_blank" 
              rel="noopener noreferrer"
              aria-label="Chat on WhatsApp"
            >
              <FaWhatsapp size={22} />
            </a>
          </div>
        </div>

        {/* COLUMN 2 */}
        <nav className="footer-col" aria-labelledby="footer-nav-title">
          <h4 id="footer-nav-title">Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/self-drive-cars">Self Drive Fleet</Link></li>
            <li><Link to="/temple-tours">Temple Tour Packages</Link></li>
            <li><Link to="/gallery">Fleet Gallery</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
          </ul>
        </nav>

        {/* COLUMN 3 */}
        <div className="footer-col map-col">
          <h4>Find Us on Maps</h4>
          <div className="map-wrapper">
            <a 
              href="https://maps.app.goo.gl/kNgeft6JzZjMwLse7"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Open location in Google Maps"
            >
              <iframe 
                title="Shree Ram Car Rental Location"
                src="https://www.google.com/maps?q=22.6737391,75.8804034&z=15&output=embed"
                width="100%" 
                height="150" 
                style={{ border: 0, borderRadius: "8px" }} 
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade">
              </iframe>
            </a>
          </div>
        </div>

        {/* COLUMN 4 */}
        <address className="footer-col contact-col">
          <h4>Contact Indore Office</h4>

          <div className="contact-item">
            <FaMapMarkerAlt className="icon" />
            <span>Shop No 1, Bhavna Nagar, Sapna Sangeeta Rd, Limbodi, Indore</span>
          </div>

          <div className="contact-item">
            <FaPhoneAlt className="icon" />
            <a href="tel:+919755357721">
              +91 97553 57721
            </a>
          </div>

          <div className="contact-item">
            <FaEnvelope className="icon" />
            <a href="mailto:shreeramcarrental1@gmail.com">
              shreeramcarrental1@gmail.com
            </a>
          </div>

          <div className="booking-badge">
            Self Drive starting at <span>₹1400/-</span>
          </div>
        </address>

      </div>

      <div className="footer-bottom">
        <p>© {currentYear} Shree Ram Car Rental Indore. All Rights Reserved.</p>
        <div className="footer-bottom-links">
          <span>Trusted 24x7 Rental Partner in Central India</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;